import { render } from "./orderConfirm.vue?vue&type=template&id=3e2221fe&scoped=true"
import script from "./orderConfirm.vue?vue&type=script&lang=js"
export * from "./orderConfirm.vue?vue&type=script&lang=js"

import "./orderConfirm.vue?vue&type=style&index=0&id=3e2221fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2221fe"]])

export default __exports__